<template>
  <div class="table-cell table-cell-select-group border-0">
    <button class="btn btn-link" @click="onSelectGroup({ group })">
      <i class="bi bi-people-fill fs-5"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: 'PulsTableSelectGroupCell',
  props: {
    group: {
      type: Object,
      required: true
    },
    onSelectGroup: {
      type: Function,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
.table-cell-select-group:hover > button > i {
  color: var(--kt-primary-active);
}
</style>
